import one360 from './one360';
import type { VotReportPayload, VotReportResponse, VotDriveFilesResponse } from '../../interfaces/vot';

export const submitVotReport = async (
  projectId: string,
  payload: VotReportPayload
): Promise<VotReportResponse> =>
  one360.post<VotReportResponse>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/vot-report`, payload, {
    timeout: 90000,
  });

export const listVotDriveFiles = async (
  projectId: string,
  prefix?: string
): Promise<VotDriveFilesResponse> =>
  one360.get<VotDriveFilesResponse>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/vot-drive-files`, {
    params: prefix ? { prefix } : undefined,
    timeout: 90000,
  });
